<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NB6xtv/tc-custom/9798368807799.jpg?1743800042760" alt="This image is the cover for the book Newburn #13, Newburn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Newburn #13, Newburn
      </h1>
      <p class="bookDescription body article font2">
        <p>Past lies are catching up to Emily and Newburn and putting them in the crosshairs on all sides.PLUS: Tabletop gamers plot a perilous heist in LOADED DICE by AMY CHASE and FABIAN LELAY.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacob Phillips, Jacob Phillips, Fabian Lelay
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf540628